/*** IMPORTS FROM imports-loader ***/
var global = window;

import v35 from './v35.js';
import md5 from './md5.js';
const v3 = v35('v3', 0x30, md5);
export default v3;
